import React from "react";
import styled from "styled-components";


const Spacer = styled.div`
    ${({fill, size}) => fill ? 'flex: 1' : `width: ${size}px`};
    height: 0;
    ${({debug}) => debug ? 'border: 1px dashed green;' : '' }
`;

export default ({fill=false, size=10, style, debug=false}) => (
    <Spacer size={size} debug={debug} style={style} fill={fill} />
)
